import { NavigateNextOutlined } from '@mui/icons-material'
import { Box, Breadcrumbs } from '@mui/material'
import usePath from 'hooks/usePath'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import ROUTES from 'utils/constants/routesConstant'

const CustomBreadcrumbs = () => {
  const { t } = useTranslation('home')
  const { path } = usePath()

  const routesName = [
    {
      name: t('home'),
      path: ROUTES.HOME,
    },
    {
      name: t('vehicle'),
      path: ROUTES.VEHICLE,
    },
    {
      name: t('vehicle_for_rent'),
      path: ROUTES.VEHICLE,
    },
    {
      name: t('vehicle_for_rent_detail'),
      path: ROUTES.VEHICLE_DETAIL,
    },
    {
      name: t('project'),
      path: ROUTES.PROJECT,
    },
    {
      name: t('for_rent'),
      path: ROUTES.FOR_RENT,
    },
    {
      name: t('bds'),
      path: ROUTES.HOUSE,
    },
    {
      name: t('bds_hot'),
      path: ROUTES.HOUSE_HOT,
    },
    {
      name: t('bds_favorite'),
      path: ROUTES.HOUSE_FAVORITE,
    },
    {
      name: t('bds_for_sell'),
      path: ROUTES.NEED_SELL,
    },
    {
      name: t('bds_for_rent_detail'),
      path: ROUTES.BDS_FOR_RENT_DETAIL,
    },
    {
      name: t('flash_sale'),
      path: ROUTES.FLASH_SALE_IN_DAY,
    },
    {
      name: t('flash_sale_in_day'),
      path: ROUTES.FLASH_SALE_IN_DAY_COMMING,
    },
    {
      name: t('news'),
      path: ROUTES.NEWS,
    },
    {
      name: t('profile'),
      path: ROUTES.PROFILE,
    },
    {
      name: t('land'),
      path: ROUTES.NEWS_DETAIL,
    },
    {
      name: t('favorite'),
      path: ROUTES.FAVORITE_LIST,
    },
  ]

  const routes = React.useMemo(() => {
    const originalPath = path.trim().split('/')
    const routesArray: string[] = []
    for (const id in originalPath) {
      const currentItem = Number(id) > 1 ? routesArray[Number(id) - 1] : ''
      routesArray.push(currentItem + '/' + originalPath[id])
    }
    return routesArray
  }, [path])

  return (
    <Box className="flex min-h-[67px] bg-background-1 items-center px-[60px]">
      <Breadcrumbs separator={<NavigateNextOutlined style={{ height: 20 }} />} aria-label="breadcrumb">
        {routes.map((item, index) => (
          <Box key={index}>
            {index < routes.length - 1 ? (
              <Link
                key={index}
                to={`${item}`}
                className="text-content-14 text-brand-1 hover:bg-brand-1 hover:text-white px-2 rounded-lg"
              >
                {routesName?.find(x => x.path === item)?.name}
              </Link>
            ) : (
              <Box className="text-content-14 text-brand-1 font-bold">
                {routesName?.find(x => x.path === item)?.name}
              </Box>
            )}
          </Box>
        ))}
      </Breadcrumbs>
    </Box>
  )
}

export default CustomBreadcrumbs
